import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import AgentModel from '../../Agent/models/AgentModel';

interface AgentSelectorState {
    searchResults: AgentModel[],
}

const initialState: AgentSelectorState = {
    searchResults: [],
}

export const AgentSelectorSlice = createSlice({
    name: "AgentSelector",
    initialState,
    reducers: {
        setAgentSelectorSearchResults: (state, action: PayloadAction<AgentModel[]>) => {
            state.searchResults = action.payload;
        },
    }
});

export const AgentSelectorSelector = createSelector(
    (state: RootState) => state.agentSelector,
    (data) => data
);

export const {
    setAgentSelectorSearchResults,
} = AgentSelectorSlice.actions;

export default AgentSelectorSlice.reducer;